export default __webpack_public_path__ + "static/Lawyer of distinction-6e9a0e5c0c7017b3bf79544bd42039b3.png";